@import './pk-badge.variables';

:host {
  @apply inline-block h-[var(--badge--size)] w-[var(--badge--size)] bg-[color:var(--badge--background)];
}

:host(.pk-badge--rounded) {
  @apply overflow-hidden rounded-[50%];
}

:host(.pk-badge--rhombus) {
  clip-path: polygon(50% 0, 100% 50%, 50% 100%, 0 50%);
}
